import { faHeart } from "@jewlr/pro-light-svg-icons/faHeart"
import {
  Box,
  Button,
  Divider,
  Flex,
  FontAwesomeIcon,
  Shimmer,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { fetchCartShare } from "app-store-v2/share/actions"
import { openModal } from "components/modal"
import fetchWishlist from "hoc/fetch-wishlist"

import LineItem from "./line-item"

const Heading = styled(Typography).attrs({
  as: "h1",
  fontSize: { _: "26px", tablet: "34px" },
  fontWeight: "700",
  letterSpacing: { _: "-0.01em", tablet: "-0.02em" },
  lineHeight: { _: "30px", tablet: "48px" },
})``

const Share = styled(Button).attrs({
  color: "primary",
  fontSize: "16px",
  lineHeight: "22px",
  underline: true,
  variant: "text",
})``

const Grid = styled(Box).attrs({
  display: "grid",
  gridGap: { _: "12px", tablet: 3 },
  gridTemplateColumns: {
    _: "repeat(2, 1fr)",
    desktop: "repeat(4, 1fr)",
    tablet: "repeat(3, 1fr)",
  },
})``

const Text = styled(Typography)`
  font-size: 20px;
  letter-spacing: -0.02em;
  line-height: 22px;
  ${(props) => props.theme.mediaQueries.tablet`
    font-size: 22px;
    line-height: 24px;
    width: 585px;
  `}
`

const InternalMain = ({ count, items, loading, openShareModal }) => (
  <>
    <Flex alignItems="center" justifyContent="space-between">
      <Heading>My Wish List</Heading>
      {loading ? (
        <Shimmer height="22px" width="100px" />
      ) : count > 0 ? (
        <Share onClick={openShareModal}>Share Wish List</Share>
      ) : null}
    </Flex>
    <Divider color="grey.20" mb={3} mt={{ _: 2, tablet: "10px" }} />
    {!loading && count == 0 ? (
      <>
        <Text bold>Your Wish List is currently empty.</Text>
        <br />
        <Text>
          Click the heart symbol [{" "}
          <FontAwesomeIcon color="black" icon={faHeart} /> ] beside any item you
          want to save and it will show here.
        </Text>
      </>
    ) : (
      <Grid>
        {loading
          ? [...Array(4)].map((_, index) => (
              <Shimmer
                height={{ _: "228px", tablet: "278px" }}
                key={index}
                width="100%"
              />
            ))
          : items.map((item) => <LineItem item={item} key={item.id} />)}
      </Grid>
    )}
  </>
)

InternalMain.propTypes = {
  count: PropTypes.number,
  fetchWishList: PropTypes.func,
  items: PropTypes.array,
  loading: PropTypes.bool,
  openShareModal: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    count: state.wishlist.count,
    items: state.wishlist.line_items,
    loading: !state.wishlist.show,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openShareModal: () => {
      dispatch(fetchCartShare("wishlist"))
      openModal("#share-modal")
    },
  }
}

const Main = fetchWishlist(InternalMain)

export default connect(mapStateToProps, mapDispatchToProps)(Main)
